import React, { useEffect, useState } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { Link } from 'react-router-dom';
import { LoaderIcon, UsersIcon, AlertCircleIcon, ArrowLeftIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { getTeacherStudents } from '../../services/studentService';
export const StudentDataCheck = () => {
  const {
    currentUser
  } = useAuth();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Load students from Firestore
  useEffect(() => {
    const loadStudents = async () => {
      if (!currentUser) {
        setLoading(false);
        setError('Please log in to view your students');
        return;
      }
      try {
        setLoading(true);
        setError(null);
        console.log('Fetching students for user:', currentUser.uid);
        const fetchedStudents = await getTeacherStudents(currentUser.uid);
        console.log('Fetched students:', fetchedStudents);
        setStudents(fetchedStudents);
      } catch (err) {
        console.error('Error loading students:', err);
        setError('Failed to load students. Please try refreshing the page.');
      } finally {
        setLoading(false);
      }
    };
    loadStudents();
  }, [currentUser]);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-6357">
      <Navbar data-id="element-6358" />
      <main className="pt-20 pb-16" data-id="element-6359">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-6360">
          <div className="flex items-center mb-6" data-id="element-6361">
            <Link to="/teacher-dashboard" className="mr-4 p-2 rounded-full hover:bg-white/10 transition-colors" data-id="element-6362">
              <ArrowLeftIcon className="h-5 w-5" data-id="element-6363" />
            </Link>
            <div data-id="element-6364">
              <h1 className="text-3xl font-serif font-bold text-white" data-id="element-6365">
                Student Data Check
              </h1>
              <p className="text-gray-300" data-id="element-6366">
                Verify your student account information
              </p>
            </div>
          </div>
          {/* Main Content */}
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8" data-id="element-6367">
            <div className="flex items-center mb-6" data-id="element-6368">
              <UsersIcon className="h-6 w-6 mr-3 text-deep-pink" data-id="element-6369" />
              <h2 className="text-xl font-medium text-white" data-id="element-6370">
                Student Account Summary
              </h2>
            </div>
            {/* Loading State */}
            {loading && <div className="flex justify-center items-center py-12" data-id="element-6371">
                <LoaderIcon className="h-8 w-8 text-deep-pink animate-spin" data-id="element-6372" />
                <span className="ml-3 text-white" data-id="element-6373">Loading student data...</span>
              </div>}
            {/* Error State */}
            {error && !loading && <div className="bg-red-900/30 text-red-200 p-4 rounded-xl mb-6" data-id="element-6374">
                <div className="flex items-start" data-id="element-6375">
                  <AlertCircleIcon className="h-5 w-5 mr-2 mt-0.5" data-id="element-6376" />
                  <div data-id="element-6377">
                    <p className="font-medium" data-id="element-6378">Error retrieving student data</p>
                    <p className="mt-1" data-id="element-6379">{error}</p>
                  </div>
                </div>
                <button onClick={() => window.location.reload()} className="mt-3 text-sm text-white bg-red-700/50 hover:bg-red-700 px-3 py-1 rounded-md transition-colors" data-id="element-6380">
                  Try Again
                </button>
              </div>}
            {/* Results */}
            {!loading && !error && <div data-id="element-6381">
                <div className="mb-6 bg-deep-pink/20 rounded-lg p-4" data-id="element-6382">
                  <p className="text-lg font-medium" data-id="element-6383">
                    Total Students:{' '}
                    <span className="text-xl font-bold" data-id="element-6384">{students.length}</span>
                  </p>
                </div>
                {students.length === 0 ? <div className="text-center py-8" data-id="element-6385">
                    <p className="text-gray-300 mb-4" data-id="element-6386">
                      No students found in your account
                    </p>
                    <Link to="/my-students" className="inline-block bg-deep-pink hover:bg-burgundy text-white py-2 px-4 rounded-lg transition-colors" data-id="element-6387">
                      Add Students
                    </Link>
                  </div> : <div data-id="element-6388">
                    <div className="overflow-x-auto" data-id="element-6389">
                      <table className="min-w-full divide-y divide-white/10" data-id="element-6390">
                        <thead data-id="element-6391">
                          <tr data-id="element-6392">
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6393">
                              Name
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6394">
                              Email
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6395">
                              Instrument(s)
                            </th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-300 uppercase tracking-wider" data-id="element-6396">
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-white/10" data-id="element-6397">
                          {students.map(student => <tr key={student.id} className="hover:bg-white/5" data-id="element-6398">
                              <td className="px-4 py-3 whitespace-nowrap" data-id="element-6399">
                                {student.name}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap text-gray-300" data-id="element-6400">
                                {student.email}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap" data-id="element-6401">
                                {student.instruments.join(', ')}
                              </td>
                              <td className="px-4 py-3 whitespace-nowrap" data-id="element-6402">
                                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${student.status === 'active' ? 'bg-green-900/30 text-green-200' : student.status === 'pending' ? 'bg-yellow-900/30 text-yellow-200' : student.status === 'trial' ? 'bg-blue-900/30 text-blue-200' : 'bg-gray-800 text-gray-300'}`} data-id="element-6403">
                                  {student.status.charAt(0).toUpperCase() + student.status.slice(1)}
                                </span>
                              </td>
                            </tr>)}
                        </tbody>
                      </table>
                    </div>
                    <div className="mt-6 text-sm text-gray-400" data-id="element-6404">
                      <p data-id="element-6405">
                        This information is retrieved directly from your
                        Firestore database. If you're not seeing expected
                        students, check:
                      </p>
                      <ul className="list-disc list-inside mt-2 space-y-1 ml-2" data-id="element-6406">
                        <li data-id="element-6407">
                          You're logged in with the correct teacher account
                        </li>
                        <li data-id="element-6408">
                          Students have been properly added through the Add
                          Student form
                        </li>
                        <li data-id="element-6409">Your database connection is working correctly</li>
                      </ul>
                    </div>
                  </div>}
              </div>}
          </div>
        </div>
      </main>
      <Footer data-id="element-6410" />
    </div>;
};